export type InsightsRole = { kind: 'admin' } | { kind: 'viewer' }

/**
 * The role a set of ID token claims grants on the dashboard, or null for none.
 *
 * Null for anything unrecognised is what makes the guard default-deny: every
 * account in the project — app users, advisers — shares this Auth pool, and
 * none of them has a dashboard. Mirrors `mayRead` in
 * functions/src/insights/getInsightsPayload.ts, which is the real gate; this
 * one only decides what to render.
 */
export const resolveInsightsRole = (
  claims: Record<string, unknown>
): InsightsRole | null => {
  // Admin first: it is strictly the larger role (it also sees team_accounts).
  if (claims.admin === true) return { kind: 'admin' }
  if (claims.insights === true) return { kind: 'viewer' }
  return null
}
